import { render, staticRenderFns } from "./Election.vue?vue&type=template&id=4614cc1d&scoped=true&"
import script from "./Election.vue?vue&type=script&lang=ts&"
export * from "./Election.vue?vue&type=script&lang=ts&"
import style0 from "./Election.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Election.vue?vue&type=style&index=1&id=4614cc1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614cc1d",
  null
  
)

export default component.exports